import React from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useTheme,
    useMediaQuery,
    Typography,
    CircularProgress,
    Alert,
    IconButton,
    Tooltip,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../contexts/AuthContext';
import { format } from 'date-fns/format';
import { tr } from 'date-fns/locale';  
import { getDevamsizlik } from '../../../services/api/devamsizlikService';
import { DevamsizlikError } from '../../../types/ErrorModals/DevamsizlikError';

const Devamsizlik: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { kullaniciModal } = useAuth();

    const { data, isLoading, error } = useQuery({
        queryKey: ['devamsizlik', kullaniciModal?.id],
        queryFn: async () => {
            try {
                return await getDevamsizlik({
                    kurumKodu: localStorage.getItem('kurumKodu') || '',
                    ogrenciId: kullaniciModal?.id || ''
                });
            } catch (err) {
                const devamsizlikError = err as DevamsizlikError;
                throw new Error(devamsizlikError.message);
            }
        },
        enabled: !!kullaniciModal?.id,
        retry: 1
    });

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Alert
                severity="error"
                sx={{ mt: 2 }}
                action={
                    process.env.NODE_ENV === 'development' && (
                        <Typography variant="caption" display="block">
                            CorrelationId: {(error as DevamsizlikError).correlationId}
                        </Typography>
                    )
                }
            >
                {(error as Error).message}
            </Alert>
        );
    }

    if (!data?.length) {
        return (
            <Alert severity="info" sx={{ mt: 2 }}>
                Kayıtlı devamsızlık bulunmamaktadır.
            </Alert>
        );
    } 

    return (
        <Box sx={{ overflowX: "auto", mt: { xs: 2, sm: 3 } }}>
            <TableContainer component={Paper} sx={{ minWidth: isMobile ? 600 : 800 }}>
                <Table aria-label="devamsızlıklar tablosu">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#6e6e6e", color: "white" }}>
                                Tarih
                            </TableCell>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#6e6e6e", color: "white" }}>
                                Devamsızlık
                            </TableCell>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#6e6e6e", color: "white" }}>
                                Tür
                            </TableCell> 
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((devamsizlik, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                                    "&:hover": {
                                        backgroundColor: "rgba(232, 137, 16, 0.1)",
                                        transition: "background-color 0.3s ease",
                                    },
                                }}
                            >
                                <TableCell>
                                    {format(new Date(devamsizlik.dersTarihi), 'dd MMMM yyyy', { locale: tr })}
                                </TableCell>
                                <TableCell>{devamsizlik.dersDevamsizlik}</TableCell>
                                <TableCell>{devamsizlik.devamsizlikTuru}</TableCell> 
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Devamsizlik;